export const formItemLayout = {
  labelCol: {
    lg: { span: 6 }
  },
  wrapperCol: {
    lg: { span: 18 }
  }
};
